export const LOAD_ALL_USERS_REQUEST = "LOAD_ALL_USERS_REQUEST";
export const LOAD_ALL_USERS_SUCCESS = "LOAD_ALL_USERS_SUCCESS";
export const LOAD_ALL_USERS_FAIL = "LOAD_ALL_USERS_FAIL";

export const ADD_USER_REQUEST = "ADD_USER_REQUEST";
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS";
export const ADD_USER_RESET = "ADD_USER_RESET";
export const ADD_USER_FAIL = "ADD_USER_FAIL";


export const UPDATE_PROFILE_REQUEST = "UPDATE_PROFILE_REQUEST";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_RESET = "UPDATE_PROFILE_RESET";
export const UPDATE_PROFILE_FAIL = "UPDATE_PROFILE_FAIL";

export const UPDATE_PASSWORD_REQUEST = "UPDATE_PASSWORD_REQUEST";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_RESET = "UPDATE_PASSWORD_RESET";
export const UPDATE_PASSWORD_FAIL = "UPDATE_PASSWORD_FAIL";

export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_RESET = "CHANGE_PASSWORD_RESET";
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL";

export const ASSIGN_ROLE_REQUEST = "ASSIGN_ROLE_REQUEST";
export const ASSIGN_ROLE_SUCCESS = "ASSIGN_ROLE_SUCCESS";
export const ASSIGN_ROLE_RESET = "ASSIGN_ROLE_RESET";
export const ASSIGN_ROLE_FAIL = "ASSIGN_ROLE_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
